import axios from 'axios';
import config from '../config/config';

const QuestionnaireisSetup = async (QuestionPayload) => {
  try {
    const data = {
      ...QuestionPayload,
    };

    const url = `${config.backendUrl}/v1/main/users/upsert-questionnaire`;
    return await axios({
      method: 'POST',
      url,
      data,
      headers: {
        'Content-Type': 'application/json',
        // 'X-AUTH-CLIENT': config.API_TOKEN,
        // 'X-HMAC-SIGNATURE': config.generateSignature(data , config.API_SECRET )
      },
    });
  } catch (error) {
    console.log("error: ",error)
    if(error.code === "ERR_BAD_REQUEST"){
      return error.response
    }
    return {
      status: 404,
    };
  }
};

export default QuestionnaireisSetup;